import { useTaskDrag } from "../hooks/useDragAndDrop";
import "../styles/board.css";

const TaskCard = ({
  task,
  assignee,
  onClick,
  onDone,
  onSelect,
  selected,
  selectedTasks    // ⭐ added
}) => {
  const { dragRef, isDragging } = useTaskDrag(task, selectedTasks); // ⭐ send selected tasks to drag hook

  return (
    <div
      ref={dragRef}
      className={`task-card ${isDragging ? "task-card-dragging" : ""} ${
        selected ? "task-selected" : ""
      }`}
    >
      <input
        type="checkbox"
        className="task-select-checkbox"
        checked={selected}
        onChange={(e) => {
          e.stopPropagation();
          onSelect(task.id);
        }}
      />

      <div onClick={onClick} className="task-click">
        <div className="task-title">{task.title}</div>
        {task.description && <div className="task-desc">{task.description}</div>}
        <div className="task-meta">
          <span className={`badge badge-${task.priority.toLowerCase()}`}>
            {task.priority}
          </span>
          {task.dueDate && <span className="badge badge-date">{task.dueDate}</span>}
          {task.status === "Completed" && (
            <span className="badge badge-completed">✓ Completed</span>
          )}
        </div>
      </div>

      {task.status !== "Completed" && (
        <button
          className="btn-small btn-done"
          onClick={(e) => {
            e.stopPropagation();
            onDone(task.id);
          }}
        >
          Done
        </button>
      )}
    </div>
  );
};

export default TaskCard;
